import type { SimulationSelection } from '@/types'

import { useCallback, useState } from 'react'

export const LEAD_FORM_SECTION_ID = 'contato'

export const LEAD_FORM_FIRST_FIELD_ID = 'proposta-nome'

interface ProposalSelection {
    selection: SimulationSelection | null
    requestProposal: (selection: SimulationSelection) => void
    clearSelection: () => void
}

export const useProposalSelection = (): ProposalSelection => {
    const [selection, setSelection] = useState<SimulationSelection | null>(null)

    const requestProposal = useCallback((next: SimulationSelection): void => {
        setSelection(next)

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

        document.getElementById(LEAD_FORM_SECTION_ID)?.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start'
        })

        window.setTimeout(() => {
            document.getElementById(LEAD_FORM_FIRST_FIELD_ID)?.focus({ preventScroll: true })
        }, reduceMotion ? 0 : 500)
    }, [])

    const clearSelection = useCallback((): void => setSelection(null), [])

    return {
        selection,
        requestProposal,
        clearSelection
    }
}
